import { UserData } from '@backend/user'
import http from '@lib/http'

export async function postMedCred(data: UserData, config?: any) {
  return await http.post('/api/medcred', data, config)
}
